import type { RiveFit, Align } from "./index";

// object-cover on a `Contain` animation crops artwork the Rive would letterbox.
// FitWidth/FitHeight have no CSS equivalent, so they take the non-cropping one.
export const FIT_TO_OBJECT_FIT: Record<RiveFit, string> = {
  Cover: "object-cover",
  Contain: "object-contain",
  Fill: "object-fill",
  FitWidth: "object-contain",
  FitHeight: "object-contain",
  None: "object-none",
  ScaleDown: "object-scale-down",
  Layout: "object-contain",
};

export const ALIGN_TO_OBJECT_POSITION: Record<Align, string> = {
  Center: "object-center",
  TopLeft: "object-left-top",
  TopCenter: "object-top",
  TopRight: "object-right-top",
  CenterLeft: "object-left",
  CenterRight: "object-right",
  BottomLeft: "object-left-bottom",
  BottomCenter: "object-bottom",
  BottomRight: "object-right-bottom",
};
